






































































import Vue from 'vue';
import { ErrorCodes } from '@ringana/errors';
import { IProduct } from '@/common/interfaces/products.interface';
import Anchor from '@/components/common/anchor/Anchor.vue';
import { EAnchor } from '@/common/enums/anchor.enum';
import PartnerInfo from '@/components/partnershop/PartnerInfo.vue';
import PartnerMap from '@/components/partnershop/PartnerMap.vue';
import PartnershopNotification from '@/components/partnershop/PartnershopNotification.vue';
import BlogSection from './subcomponents/BlogSection.vue';
import SliderSection from './subcomponents/SliderSection.vue';
import TextSection from './subcomponents/TextSection.vue';
import BoxSection from './subcomponents/BoxSection.vue';
import QuickLinkSection from './subcomponents/QuickLinkSection.vue';
import SocialMediaSection from './subcomponents/SocialMediaSection.vue';
import NewsletterSection from './subcomponents/NewsletterSection.vue';
import BestSellersSection from './subcomponents/BestSellersSection.vue';
import LocalStorageHelper from '../../helpers/LocalStorageHelper';
import {
  IBlogEntry,
  IBox,
  INewsletterFormData,
  IQuickLink,
  ISlide,
  ISocialMedia,
} from '../../common/interfaces/frontpage.interface';
import LoadingSpinner from '../common/loading/LoadingSpinner.vue';
import BlogSectionMobile from '@/components/frontpage/subcomponents/BlogSectionMobile.vue';
import TrackingHelper from '@/helpers/TrackingHelper';
import EventListenerHelper from '@/helpers/EventListenerHelper';
import { IEventListener } from '@/common/interfaces/index.interface';
import FetchError from '@/errors/fetch-error';

interface IFrontpageComponent {
  EAnchor: typeof EAnchor;
  bestSellerProducts: IProduct[];
  blogEntries: IBlogEntry[];
  boxes: IBox[];
  documentEventListeners: IEventListener[];
  isPartner: boolean;
  isPartnerShop: boolean | null;
  loading: boolean;
  quickLinks: IQuickLink[];
  registrationInProgress: boolean;
  shoppingAllowed: boolean;
  slides: ISlide[];
  socialMedias: ISocialMedia[];
}

export default Vue.extend({
  name: `Frontpage`,
  components: {
    Anchor,
    BestSellersSection,
    BlogSection,
    BlogSectionMobile,
    BoxSection,
    LoadingSpinner,
    NewsletterSection,
    PartnerInfo,
    PartnerMap,
    PartnershopNotification,
    QuickLinkSection,
    SliderSection,
    SocialMediaSection,
    TextSection,
  },
  data(): IFrontpageComponent {
    return {
      EAnchor,
      bestSellerProducts: [],
      blogEntries: [],
      boxes: [],
      documentEventListeners: [],
      isPartner: false,
      isPartnerShop: null,
      loading: true,
      quickLinks: [],
      registrationInProgress: false,
      shoppingAllowed: true,
      slides: [],
      socialMedias: [],
    };
  },
  computed: {
    firstTextSectionTranslations(): string[] {
      return [
        this.$t(`frontpage-ufe:firstTextSection.line1`),
        this.$t(`frontpage-ufe:firstTextSection.line2`),
        this.$t(`frontpage-ufe:firstTextSection.line3`),
      ];
    },
    secondTextSectionTranslations(): string[] {
      return [
        this.$t(`frontpage-ufe:secondTextSection.line1`),
        this.$t(`frontpage-ufe:secondTextSection.line2`),
        this.$t(`frontpage-ufe:secondTextSection.line3`),
      ];
    },
  },
  created(): void {
    this.documentEventListeners = [
      { callback: this.updateShoppingAllowed, name: `rin-limiting-shopping-allowed` },
      { callback: this.updateShoppingDisallowed, name: `rin-limiting-shopping-disallowed` },
    ];
  },
  async mounted(): Promise<void> {
    EventListenerHelper.setUpEventListeners(this.documentEventListeners);
    this.checkPartnerShopStatus();
    this.isPartner = LocalStorageHelper.getPersonalInfo()?.isPartner ?? false;
    [
      this.bestSellerProducts,
      this.blogEntries,
      this.boxes,
      this.quickLinks,
      this.slides,
      this.socialMedias,
    ] = await Promise.all([
      this.$productService.getHomepageOfferProducts(),
      this.$frontpageService.getBlogEntries(),
      this.$frontpageService.getBoxes(),
      this.$frontpageService.getQuickLinks(),
      this.$frontpageService.getSlides(),
      this.$frontpageService.getSocialMedias(),
    ]);
    try {
      await this.$cartService.getCarts();
    } catch (err) {
      if(!(err instanceof FetchError && err.errorCode === ErrorCodes.LIMITING_BOUNCER_ACTIVE)) {
        throw err;
      }
      // hodor is active, all good
    }
    this.loading = false;
  },
  beforeDestroy(): void {
    EventListenerHelper.teardownEventListeners(this.documentEventListeners);
  },
  methods: {
    checkPartnerShopStatus(retryPartnerShopStatusCheck = 0): void {
      this.isPartnerShop = LocalStorageHelper.getIsPartnerShop();
      if(this.isPartnerShop === null && retryPartnerShopStatusCheck < 20) {
        let retryAttempt = retryPartnerShopStatusCheck;
        retryAttempt++;
        window.setTimeout(() => this.checkPartnerShopStatus(retryAttempt), 1000);
      }
    },
    async subscribeToNewsletter(data: INewsletterFormData): Promise<void> {
      this.registrationInProgress = true;
      const success = await this.$frontpageService.subscribeToNewsletter(data);
      this.registrationInProgress = false;
      if(success) {
        TrackingHelper.trackNewsletterRegistration();
        this.$swal({
          text: this.$t(`frontpage-ufe:newsletter.success.message`).toString(),
          title: this.$t(`frontpage-ufe:newsletter.success.headline`).toString(),
          type: `success`,
        });
      } else {
        this.$swal({
          text: this.$t(`frontpage-ufe:newsletter.fail.message`).toString(),
          title: this.$t(`frontpage-ufe:newsletter.fail.headline`).toString(),
          type: `warning`,
        });
      }
    },
    unsubscribeNewsletter(): void {
      // taken from footer.php
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $(`#nlUnsubscribe`).foundation(`open`);
    },
    async updateShoppingAllowed(): Promise<void> {
      // special handling for users who log in while hodor is active
      await this.$cartService.fetchCart();
      this.shoppingAllowed = true;
    },
    updateShoppingDisallowed(): void {
      this.shoppingAllowed = false;
    },
  },
});
